module.exports = __webpack_public_path__ + "img/box1.a8f6f2f3.png";